export const INVALID_APPOINTMENT_DATE_ERROR = "invalid_appointment_date";
export const APPOINTMENT_RESERVATION_CONFLICT =
    "appointment_reservation_conflict";
export const RATE_LIMIT_EXCEEDED = "rate_limit_exceeded";
